module.exports = __webpack_public_path__ + "media/images/basic_logos/diamond-8773a6abcade8fe783ded0596e7f8913.png";